
// File: src/pages/NotFound.tsx
import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { FileQuestion } from 'lucide-react';

export default function NotFound() {
  const location = useLocation();

  // Log missing route and set page title
  useEffect(() => {
    console.error(`404 Error: No route for ${location.pathname}`);
    document.title = '404 - Page Not Found';
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full text-center space-y-6 p-6">
        <div className="rounded-full bg-muted p-3 w-16 h-16 flex items-center justify-center mx-auto">
          <FileQuestion className="h-8 w-8 text-primary" />
        </div>
        <h1 className="text-3xl font-bold">404 - Page Not Found</h1>
        <p className="text-muted-foreground">
          Sorry, the page you are looking for doesn’t exist or has moved.
        </p>
        <div className="pt-4">
          <Link to="/">
            <Button>Return to Dashboard</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}